import { ChangeDetectionStrategy, Component, EventEmitter, Input, type OnInit, Output, ViewChild } from '@angular/core';
import type { PopoverDirective } from 'ngx-bootstrap/popover';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { BsDatepickerModule, type BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

@Component({
    selector: 'web-date-picker',
    templateUrl: './web-date-picker.component.html',
    styleUrls: ['./web-date-picker.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        PopoverModule,
        TimepickerModule,
        BsDatepickerModule,
        FormsModule,
        TranslateModule,
    ],
})
export class WebDatePickerComponent implements OnInit {
    @Input() defaultDate: Date;
    @Input() popoverPos: string = 'auto';
    @Input() minDate?: Date;

    public datePickerConfig: Partial<BsDatepickerConfig> = {
        dateInputFormat: 'YYYY-MM-DD',
        isAnimated: true,
        displayOneMonthRange: true,
        showWeekNumbers: false,
        selectWeek: false,
        containerClass: 'theme-blue',
    };

    public date: Date;
    public bsInlineValue: Date;

    @Output() dateChange = new EventEmitter<Date>();

    @ViewChild('popoverRef') private _popoverRef: PopoverDirective;

    ngOnInit() {
        this.date = this.defaultDate || this.minDate;
    }

    public dateSelectionDone(ev: any): void {
        this.date = ev;
        console.log('dateSelectionDone', this.date);
        this.dateChange.emit(this.date);

        this._popoverRef.hide();
    }

    public onClose(): void {
        this._popoverRef.hide();
    }
}
